import { defineComponent as _defineComponent } from 'vue'
import TradeListing from '../../components/lists/TradeListing.vue';
import { tradeReportTableFieldsFull } from '../../models/tradeTableFields';
import { ExportListType, HedgingInstruments, TradeState, PaginatedParams, TradeStatus } from 'ah-api-gateways';
import ListDownloadButton from 'ah-common-lib/src/common/components/listing/ListDownloadButton.vue';
import TradeRowDetails from './TradeRowDetails.vue';
import TradeListFilters from '../../components/lists/TradeListFilters.vue';
import SortSelector from 'ah-common-lib/src/common/components/SortSelector.vue';
import ListBlock from 'ah-common-lib/src/common/components/listing/ListBlock.vue';
import { ref, PropType, reactive, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchableTradeList',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    required: false,
    default: () => ({ tableFields: tradeReportTableFieldsFull }),
  },
  withRowDetails: {
    type: [Boolean, String],
    required: false,
    default: false,
  },
  openTrade: {
    type: Object as PropType<any>,
    required: false,
    default: () => null,
  },
  possibleStates: {
    type: Array as PropType<TradeState[]>,
    required: false,
  },
  possibleStatuses: {
    type: Array as PropType<TradeStatus[]>,
    required: false,
  },
  possibleInstruments: {
    type: Array as PropType<HedgingInstruments[]>,
    required: false,
  },
  showExport: {
    type: [Boolean, String],
    required: false,
    default: false,
  },
  readonly: {
    type: [Boolean, String],
    required: false,
    default: false,
  },
},
  setup(__props, { expose }) {

const props = __props;

const tradeListing = ref<InstanceType<typeof TradeListing> | null>(null);



const state = reactive({
  sortAndPageParams: {
    sort: 'createdAt',
    sortDirection: 'DESC',
  } as Partial<PaginatedParams>,
  defaultFilter: {} as any,
  // Automatically syncronised via .sync
  dataDownloadState: 'idle',
});

function onOpenTradeChange() {
  if (props.openTrade) {
    state.defaultFilter.referenceNumber = props.openTrade;
  }
}

watch(
  () => props.openTrade,
  () => {
    onOpenTradeChange();
  },
  { immediate: true }
);

function downloadList(format: ExportListType) {
  tradeListing.value!.downloadData(format);
}

function updateTrade() {
  tradeListing.value!.loadData();
}

function reload() {
  tradeListing.value!.loadData(undefined, true);
}

expose({ reload });

return { __sfc: true,tradeListing, props, state, onOpenTradeChange, downloadList, updateTrade, reload, TradeListing, ListDownloadButton, TradeRowDetails, TradeListFilters, SortSelector, ListBlock }
}

})